/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prettier/prettier */
import { FunctionComponent, useState } from 'react';

import styles from '../AccountCard.module.scss';
import dotsHorizontal from './dots-horizontal.svg';
import dotsVertical from './dots-vertical.svg';

export type BankAccountCardProps = {
  Name: string;
  InstitutionNumber: string;
  BanchTransitNumber: string | number;
  MaskedAccountNumber: string | number;
  BankId: number;
  InstitutionName: string;
  IsDefault: boolean;
  IsSelected: boolean;
  OnRemove: () => void;
  OnSetAsDefault: () => void;
  Color?: string;
};

type FC = FunctionComponent<BankAccountCardProps>;

const BankAccountCard: FC = ({
  Name,
  MaskedAccountNumber,
  InstitutionNumber,
  BanchTransitNumber,
  InstitutionName,
  BankId,
  IsDefault,
  IsSelected,
  OnRemove,
  OnSetAsDefault,
  Color,
}: BankAccountCardProps) => {
  const [IsSelectedComponent, setIsSelectedComponent] = useState(IsSelected);
  const toggleSelected = () => {
    setIsSelectedComponent(!IsSelectedComponent);
  };

  return (
    <div
      className={[styles.Container, styles.BankAccount, defaultClass(), selectedClass()].join(' ')}
      style={{ background: IsDefault ? Color : '' }}
    >
      {BankId === null || BankId === undefined ? (
        <img className={styles.Logo} src="/images/logos-banks/1894.svg" alt={InstitutionName} />
      ) : (
        <img className={styles.Logo} src={`/images/logos-banks/${BankId}.svg`} alt={InstitutionName} />
      )}

      {IsDefault && <div className={styles.DefaultBank}>Default Bank</div>}
      {!IsDefault && (
        <div className={styles.DefaultBank}>
          <div
            onClick={() => {
              OnSetAsDefault();
            }}
          >
            Set as default
          </div>
          {IsSelectedComponent && (
            <div
              className={styles.DefaultBankRemove}
              onClick={() => {
                OnRemove();
              }}
            >
              Remove
            </div>
          )}
        </div>
      )}
      {!IsSelectedComponent && (
        <img className={styles.Dots} src={dotsVertical} alt="menu dots" onClick={() => toggleSelected()} />
      )}
      {IsSelectedComponent && (
        <img className={styles.Dots} src={dotsHorizontal} alt="menu dots" onClick={() => toggleSelected()} />
      )}
      <div className={styles.InformationElement}>
        <div className={styles.InformationElementRow}>
          <div className={styles.InformationElementLeft}>
            <div className={styles.Label}>Name</div>
            <div className={styles.Value}>{Name}</div>
          </div>
          <div className={styles.InformationElementRight}>
            <div className={styles.Label}>Account Number</div>
            <div className={styles.Value}>{MaskedAccountNumber}</div>
          </div>
        </div>
        {IsSelectedComponent && (
          <div className={styles.InformationElementRow}>
            <div className={styles.InformationElementLeft}>
              <div className={styles.Label}>Institution Number</div>
              <div className={styles.Value}>{InstitutionNumber}</div>
            </div>
            <div className={styles.InformationElementRight}>
              <div className={styles.Label}>Transit Number</div>
              <div className={styles.Value}>{BanchTransitNumber}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
  function defaultClass(): string {
    return IsDefault ? styles.Default : '';
  }
  function selectedClass(): string {
    return IsSelectedComponent ? styles.Selected : '';
  }
};

export default BankAccountCard;
